// Textos legales — borrador estándar adaptado a los datos reales de Rawan.
// El titular puede revisarlos y ampliarlos con su NIF/CIF y datos registrale.

export const LEGAL_TEXTOS = {
  "/aviso-legal": {
    titulo: "Aviso legal",
    parrafos: [
      {
        titulo: "1. Titular",
        texto:
          "En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa de los datos identificativos del titular de este sitio web:",
        lista: [
          "Titular: Pastelería Panadería Rawan",
          "Domicilio: Carrer del Pintor Guàrdia, 11, bjs — 08560 Manlleu (Barcelona), España",
          "Teléfono: 659 10 97 98",
          "Email: Fornpastisseriarawan@gmail.com",
        ],
      },
      {
        titulo: "2. Objeto",
        texto:
          "Este sitio web tiene por objeto ofrecer información sobre los productos y servicios de Pastelería Panadería Rawan — panes, bollería, pastas tradicionales y árabes, pastelería fina, tartas personalizadas, productos salados, sushi y trampantojos — así como facilitar el contacto y la solicitud de encargos y presupuestos.",
      },
      {
        titulo: "3. Condiciones de uso",
        texto:
          "El acceso y la navegación por este sitio web atribuyen la condición de usuario e implican la aceptación de las presentes condiciones. El usuario se compromete a hacer un uso adecuado de los contenidos y servicios que se ofrecen y a no emplearlos para actividades ilícitas o contrarias a la buena fe.",
      },
      {
        titulo: "4. Propiedad intelectual e industrial",
        texto:
          "Todos los contenidos de este sitio web (textos, fotografías, logotipos, diseños e imágenes) son titularidad de Pastelería Panadería Rawan o de terceros que han autorizado su uso, y están protegidos por la normativa de propiedad intelectual e industrial. Queda prohibida su reproducción, distribución o transformación sin la autorización expresa del titular.",
      },
      {
        titulo: "5. Responsabilidad",
        texto:
          "El titular no se responsabiliza de los daños que pudieran derivarse de interferencias, omisiones, interrupciones o desconexiones ajenas a su control, ni del uso que los usuarios hagan de la información publicada. Las fotografías de los productos son representativas: los productos artesanales pueden presentar variaciones naturales.",
      },
      {
        titulo: "6. Enlaces externos",
        texto:
          "Este sitio puede incluir enlaces a sitios web de terceros (por ejemplo, redes sociales o servicios de mapas). El titular no se hace responsable de los contenidos de dichos sitios ni de las políticas de privacidad de terceros.",
      },
      {
        titulo: "7. Legislación aplicable",
        texto:
          "La relación entre el titular y los usuarios se regirá por la normativa española. Para cualquier controversia, las partes se someten a los juzgados y tribunales que correspondan conforme a derecho.",
      },
    ],
  },
  "/politica-de-privacidad": {
    titulo: "Política de privacidad",
    parrafos: [
      {
        titulo: "1. Responsable del tratamiento",
        texto:
          "Responsable: Pastelería Panadería Rawan. Domicilio: Carrer del Pintor Guàrdia, 11, bjs — 08560 Manlleu (Barcelona), España. Contacto: Fornpastisseriarawan@gmail.com · 659 10 97 98.",
      },
      {
        titulo: "2. Datos que tratamos y finalidad",
        texto:
          "Tratamos los datos que nos facilitas voluntariamente a través de los formularios de esta web (nombre, teléfono, email, mensaje y, en el caso de presupuestos, tipo de celebración, fecha, número de personas y productos solicitados) con las siguientes finalidades:",
        lista: [
          "Atender tus consultas, solicitudes de contacto y llamadas.",
          "Preparar y gestionar presupuestos para bodas, celebraciones y encargos.",
          "Mantenerte informado de tu solicitud mientras se gestiona.",
        ],
      },
      {
        titulo: "3. Legitimación",
        texto:
          "La base jurídica del tratamiento es tu consentimiento expreso, otorgado al enviar cualquiera de los formularios de esta web, así como la aplicación de medidas precontractuales solicitadas por ti (presupuestos y encargos).",
      },
      {
        titulo: "4. Conservación de los datos",
        texto:
          "Conservaremos tus datos durante el tiempo necesario para atender tu solicitud y gestionar tu encargo, y posteriormente durante los plazos legalmente exigibles. Las solicitudes que no deriven en encargo se conservarán durante un máximo de 12 meses.",
      },
      {
        titulo: "5. Destinatarios",
        texto:
          "No cedemos tus datos a terceros, salvo obligación legal o proveedores estrictamente necesarios para prestar el servicio (por ejemplo, proveedores de correo electrónico o de alojamiento web), que actúan como encargados del tratamiento con contrato conforme al RGPD.",
      },
      {
        titulo: "6. Tus derechos",
        texto:
          "Puedes ejercer tus derechos de acceso, rectificación, supresión, limitación, portabilidad y oposición escribiendo a Fornpastisseriarawan@gmail.com. También puedes presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es).",
      },
      {
        titulo: "7. Seguridad",
        texto:
          "Aplicamos medidas técnicas y organizativas apropiadas para proteger tus datos personales contra el acceso no autorizado, la pérdida o la alteración, incluyendo el acceso restringido a los sistemas donde se almacenan las solicitudes recibidas.",
      },
    ],
  },
  "/politica-de-cookies": {
    titulo: "Política de cookies",
    parrafos: [
      {
        titulo: "1. Qué son las cookies",
        texto:
          "Las cookies son pequeños archivos que se almacenan en tu dispositivo al visitar un sitio web y que permiten, entre otras cosas, recordar tu actividad o preferencias de navegación.",
      },
      {
        titulo: "2. Cookies que utiliza esta web",
        texto:
          "Esta web no utiliza cookies propias de análisis ni de publicidad. Únicamente pueden instalarse cookies estrictamente técnicas necesarias para el funcionamiento del sitio. Los mapas interactivos y otros contenidos de terceros integrados (por ejemplo, Google Maps) pueden establecer cookies propias cuando se muestran, conforme a las políticas de dichos servicios.",
        lista: [
          "Cookies técnicas: imprescindibles para el correcto funcionamiento de la web.",
          "Cookies de terceros: pueden generarse al mostrar contenidos incrustados de servicios externos (mapas, etc.).",
        ],
      },
      {
        titulo: "3. Cómo gestionar las cookies",
        texto:
          "Puedes permitir, bloquear o eliminar las cookies instaladas en tu dispositivo desde la configuración de tu navegador (Chrome, Firefox, Safari, Edge u otro). La desactivación de cookies técnicas puede afectar al funcionamiento de la web.",
      },
      {
        titulo: "4. Actualizaciones",
        texto:
          "Esta política puede actualizarse para adaptarse a cambios normativos o técnicos. Te recomendamos revisarla periódicamente. La última actualización corresponde a la fecha de publicación de esta web.",
      },
    ],
  },
};
